export default __webpack_public_path__ + "static/media/shoes.bd837da9.png";